export default "__VITE_ASSET__DC$QvxGX__"